import * as ng from 'angular';

export const StSelectRow = () => (<angular.IDirective>{

    restrict: 'A',
    require: '^stTable',
    scope: {
        row: '=stSelectRow'
    },
    link: (scope: any, element, attr, ctrl: any) => {
        let mode = attr.stSelectMode || 'single';
        element.bind('click', () => {
            scope.$apply(() => {
                ctrl.select(scope.row, mode);
            });
        });

        scope.$watch('row.isSelected', (newValue, oldValue) => {
            if (newValue === true) {
                element.addClass('st-selected');
            } else {
                element.removeClass('st-selected');
            }
        });
    }
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/third/smart-table/st-select-row/st-select-row.directive.ts